import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Heart } from "lucide-react";
import { useFavorites } from "@/context/FavoritesContext";

export default function ToolCard({ tool, index = 0 }) {
  const Icon = tool.icon;
  const { isFav, toggle } = useFavorites();
  const fav = isFav(tool.slug);

  return (
    <Link
      to={`/tools/${tool.slug}`}
      data-testid={`tool-card-${tool.slug}`}
      style={{ animationDelay: `${index * 40}ms` }}
      className="fade-up relative flex flex-col p-6 bg-white dark:bg-[#121316] rounded-xl border border-slate-200 dark:border-white/10 hover:border-blue-500/40 dark:hover:border-blue-400/40 hover:shadow-[0_12px_24px_rgba(0,0,0,0.06)] dark:hover:shadow-[0_8px_24px_rgba(0,0,0,0.4)] transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 group"
    >
      <div className="flex items-start justify-between">
        <div className="w-11 h-11 rounded-lg bg-blue-50 dark:bg-blue-500/10 text-blue-600 dark:text-blue-400 grid place-items-center transition-colors group-hover:bg-blue-600 group-hover:text-white dark:group-hover:bg-blue-500">
          <Icon size={20} strokeWidth={2} />
        </div>
        <div className="flex items-center gap-1">
          <button
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(tool.slug); }}
            data-testid={`fav-btn-${tool.slug}`}
            aria-label={fav ? "Remove from favorites" : "Add to favorites"}
            className={`p-1.5 rounded-lg transition-colors ${fav ? "text-red-500" : "text-slate-300 dark:text-slate-600 hover:text-red-500"}`}
          >
            <Heart size={16} fill={fav ? "currentColor" : "none"} />
          </button>
          <ArrowUpRight size={16} className="text-slate-300 dark:text-slate-600 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors" />
        </div>
      </div>
      <h3 className="mt-5 text-base font-semibold text-slate-900 dark:text-white">{tool.name}</h3>
      <p className="mt-1.5 text-sm text-slate-500 dark:text-slate-400 leading-relaxed">{tool.desc}</p>
    </Link>
  );
}
